/**
 * Agent Installation test case sections for Brokerage agent / Direct agent.
 * Content matches the test cases documented in:
 * - AgentInstallationCreate-TestCases.md
 * - AgentInstallationView-TestCases.md
 * - AgentInstallationEdit-TestCases.md
 *
 * Components: AgentAddInstallation, AgentViewInstallation, AgentEditInstallation (or edit mode).
 */

export const AGENT_INSTALLATION_CREATE_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Agent Add Installation (AgentAddInstallation)",
    icon: "ri-add-circle-line",
    items: [
      { id: "AIC-V01", label: "Validation: installer, email, phone, billing/installation address, dates" },
      { id: "AIC-A01", label: "Address: same-as-billing, AddAddressFormModal, AddressAutocomplete" },
      { id: "AIC-I01", label: "Installer selection" },
      { id: "AIC-S01", label: "SpecialFeeui: required/optional fees; tax and UnifiedInstallationCouponDiscount" },
      { id: "AIC-X01", label: "Submit: payload; success redirect; route brokerage agent / direct agent" },
    ],
  },
  {
    title: "2. Post type, products & status (Agent)",
    icon: "ri-layout-grid-line",
    items: [
      { id: "AIC-P01", label: "PostTypeSignConfiguration and product selection" },
      { id: "AIC-P02", label: "InstallationStatusTracker: Draft → Payment → Finalized → …" },
      { id: "AIC-N01", label: "Notes (InstructionsCreateCard)" },
    ],
  },
];

export const AGENT_INSTALLATION_VIEW_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Agent View Installation (AgentViewInstallation)",
    icon: "ri-eye-line",
    items: [
      { id: "AIV-D01", label: "Load installation by ID; display address, post type, dates, products" },
      { id: "AIV-D02", label: "Special fees, tax, coupon, notes; InstallationStatusTracker steps" },
      { id: "AIV-A01", label: "Edit link and Back; route brokerage agent / direct agent" },
    ],
  },
];

export const AGENT_INSTALLATION_EDIT_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Load and hydration (Agent Edit)",
    icon: "ri-download-cloud-line",
    items: [
      { id: "AIE-L01", label: "Load installation for edit" },
      { id: "AIE-L02", label: "Hydrate addresses" },
      { id: "AIE-L03", label: "Hydrate special fees" },
      { id: "AIE-L04", label: "Hydrate tax and coupon" },
      { id: "AIE-L05", label: "404 / not found" },
    ],
  },
  {
    title: "2. Editable vs read-only by status",
    icon: "ri-lock-line",
    items: [
      { id: "AIE-E01", label: "Draft editable" },
      { id: "AIE-E02", label: "Post-payment read-only fields" },
      { id: "AIE-E03", label: "Cancelled" },
      { id: "AIE-E04", label: "InstallationStatusTracker on edit" },
    ],
  },
  {
    title: "3. Address, installer, post type, notes, fees",
    icon: "ri-map-pin-line",
    items: [
      { id: "AIE-A01", label: "Change billing address" },
      { id: "AIE-A02", label: "Toggle same-as-billing" },
      { id: "AIE-A03", label: "Add new address (AddAddressFormModal)" },
      { id: "AIE-I01", label: "Change installer" },
      { id: "AIE-P01", label: "Change post type / sign config" },
      { id: "AIE-N01", label: "Update notes" },
      { id: "AIE-S01", label: "Change special fees" },
    ],
  },
  {
    title: "4. Save and payload (API)",
    icon: "ri-send-plane-line",
    items: [
      { id: "AIE-X01", label: "Successful save; route brokerage agent / direct agent" },
      { id: "AIE-X02", label: "Payload structure" },
      { id: "AIE-X03", label: "Save error / validation" },
    ],
  },
];
